//Some services provides trials services. To enable them this popup is rendered.
import React from "react";

import PortalOverlay from "../../../../Shared/portal-overlay/portalOverlay";
// styles
import Styles from "../../../../Shared/popup.module.scss";
import classes from "./trialActivatedPopUp.module.scss";
import {
  primaryButtonStyle,
  primaryButtonHoverStyle,
} from "../../../../Shared/buttonStyles";

// Constants

import { MEDIUM } from "../../../../Shared/buttonSize";

// Components
import Button from "../../../../Shared/button/button";
import { PartyPopper } from "lucide-react";

function TrialActivatedPopUp({ onConfirm, trial_transaction }: any) {
  return (
    <PortalOverlay>
      <div
      className={`d-flex align-items-center justify-content-center ${Styles.overlay}`}
    >
      <div
        className={`p-4 d-flex align-items-center flex-column justify-content-center ${Styles.popUpContent}`}
        style={{ width: "600px" }}
      >
        <div
          style={{ height: 70, width: 70, background: "#e5fff2" }}
          className="py-3 text-center rounded-5 p-2 d-flex align-items-center justify-content-center"
        >
          <PartyPopper size={40} color="#16b265" />
        </div>
        <div className="py-2 px-3">
          <p className={`mb-0 text-center ${classes.welcomeText}`}>
            Congratulations
          </p>
          <div className="py-2">
            <p className={`mb-0 text-center ${classes.headingText}`}>
              You have successfully enabled the service,{" "}
              <span className={classes.transactions}>
                {" "}
                {trial_transaction}{" "}
              </span>
              trial transactions have been enabled.
            </p>
          </div>
          <div className="py-2 px-3 align-items-center d-flex justify-content-center">
            <div
              style={{
                fontSize: "12px",
                backgroundColor: "#fff",
                textAlign: "center",
                color: "#6c757d",
                borderRadius: "8px",
              }}
              className={`mb-0 text p-3`}
            >
              <p
                style={{
                  textAlign: "center",
                  fontFamily: "Outfit, sans-serif",
                  fontStyle: "normal",
                  fontWeight: 600,
                  fontSize: "18px",
                  lineHeight: "28px",
                  color: "#16b265",
                }}
                className="m-0"
              >
                Note:
              </p>
              Post trial you can directly link this service to your production
              account to enable the service as per the current plan selected.
              Wallet deductions will apply accordingly.
            </div>
          </div>
        </div>
        <div className="py-1 d-flex justify-content-center">
          <div>
            <Button
              hoveredStyle={primaryButtonHoverStyle}
              style={primaryButtonStyle}
              id="product-catalog-trial-activated-confirm"
              onClick={() => onConfirm()}
              size={MEDIUM}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </div></PortalOverlay>
  );
}

export default TrialActivatedPopUp;
